import Vue from 'vue'
import Vuex from 'vuex'
import { setCookie } from '@/api/crm-api.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    User: null,
    Messages: []
  },
  mutations: {
    reset (state) {
      state.User = null
      
      localStorage.removeItem('login')
      localStorage.removeItem('password')
      setCookie("login","",-10)
      setCookie("password","",-10)
    },
    setUser (state,user) {
      state.User = user
      localStorage.login = user.login
      localStorage.password = user.password

      setCookie("login",user.login)
      setCookie("password",user.password)
    },
    addMessage(state,payload) {
      state.Messages.push(payload)
    },
    clearMessages(state) {
      state.Messages = []
    }
  },
  actions: {

  }
})
